import { SNSSQSTypes } from "@smart/itops-constructs-basic";
import { namespacedList } from "@smart/itops-types-basic";
import { keysOf } from "@smart/itops-utils-basic";

import { ActivityEventDef } from "./activity-event";
import { ActivityHeartbeatDef } from "./activity-heartbeat";
import { AnalyticsAdapterDef } from "./analytics-adapter";
import { AutoReminderDef } from "./auto-reminder";
import { BackoffDef } from "./backoff";
import { DeadLetterAnalyserDef } from "./dead-letter-analyser";
import { EventAnalyticsDef } from "./event-analytics";
import { MigrateDef } from "./migrate";
import { PDFProcessingDef } from "./pdf-processing";
import { PlanDef } from "./plan";
import { QuestionGenerationDef } from "./question-generation";
import { RequeueDef } from "./requeue";
import { SmokeballCommandResultDef } from "./smokeball-command-result";
import { SmokeballIntegrationDef } from "./smokeball-integration";
import { TranslationDef } from "./translation";

export const transports = namespacedList({
  Backoff: BackoffDef,
  Plan: PlanDef,
  Requeue: RequeueDef,
  Migrate: MigrateDef,
  SmokeballIntegration: SmokeballIntegrationDef,
  SmokeballCommandResult: SmokeballCommandResultDef,
  PDFProcessing: PDFProcessingDef,
  ActivityEvent: ActivityEventDef,
  ActivityHeartbeat: ActivityHeartbeatDef,
  QuestionGeneration: QuestionGenerationDef,
  AutoReminder: AutoReminderDef,
  Translation: TranslationDef,
  EventAnalytics: EventAnalyticsDef,
  AnalyticsAdapter: AnalyticsAdapterDef,
  DeadLetterAnalyser: DeadLetterAnalyserDef,
});

export const transportKeys = keysOf(transports);

export type Transports = typeof transports;

export type TransportKey = keyof Transports;

export type TransportTypes = SNSSQSTypes<Transports>;

export type TBackoff = TransportTypes["Backoff"];

export type TPlan = TransportTypes["Plan"];

export type TRequeue = TransportTypes["Requeue"];

export type TMigrate = TransportTypes["Migrate"];

export type TSmokeballIntegration = TransportTypes["SmokeballIntegration"];

export type TPDFProcessing = TransportTypes["PDFProcessing"];

export type TActivityEvent = TransportTypes["ActivityEvent"];

export type TActivityHeartbeat = TransportTypes["ActivityHeartbeat"];

export type TQuestionGeneration = TransportTypes["QuestionGeneration"];

export type TAutoReminder = TransportTypes["AutoReminder"];

export type TTranslation = TransportTypes["Translation"];

export type TEventAnalytics = TransportTypes["EventAnalytics"];

export type TAnalyticsAdapter = TransportTypes["AnalyticsAdapter"];

export type TDeadLetterAnalyser = TransportTypes["DeadLetterAnalyser"];

export type TSmokeballCommandResult = TransportTypes["SmokeballCommandResult"];
